import {ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {AbstractVisbosComponent} from "../../abstract-visbos.component";
import {SessionActions} from "../../../../../shared/actions/session.actions";
import {UserService} from "../../../../../crm/user/user.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {PasswordChangeValidation} from "../password-change.validator";
import {MessageType} from "../../../../../shared/redux-store/session/session.types";

@Component({
  selector: 'vb-password-reset-form',
  templateUrl: './password-reset-form.component.html',
  styleUrls: ['./password-reset-form.component.css']
})
export class PasswordResetFormComponent extends AbstractVisbosComponent implements OnInit {

  form: FormGroup;

  constructor(sessionActions: SessionActions, private fb: FormBuilder, private route: ActivatedRoute, private router: Router,
              private userService: UserService, cd: ChangeDetectorRef) {
    super(sessionActions, cd);

    this.form = this.fb.group({
      token: [null, Validators.required],
      email: [null, Validators.compose([Validators.required, Validators.email])],
      password: [null, Validators.required],
      password_confirmation: [null]
    }, {
      validator: PasswordChangeValidation.passwordMatchValidation('password', 'password_confirmation')
    });

  }

  ngOnInit() {
    super.ngOnInit();

    this.dataSubscriptions.push(
      this.route.params.subscribe(params => {
        if (params['token']) {
          this.form.get('token').setValue(params['token']);
        }
      })
    );

  }

  onPasswordChangeClicked() {
    this.userService.resetPasswordWithToken(this.form.value)
      .subscribe(res => {
          this.sessionActions.pushMessage("Das Passwort wurde erfolgreich zurückgesetzt, sie werden nun zur Anmeldeseite weitergeleitet!", MessageType.SUCCESS, "Password zurücksetzen");
          setTimeout(() => this.router.navigate(['/login']), 5000);
        },
        error => {
          console.error("Fehler", [error]);
          const body = error.json() || '';
          const err = body.error || JSON.stringify(body);
          this.sessionActions.pushMessage("Es ist ein Fehler aufgetreten: " + err, MessageType.ERROR, "Passwort zurücksetzen");
        });
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/components/password-change/password-reset-form/password-reset-form.component.ts